import { schema } from 'normalizr';

const documentScheme = new schema.Entity('document');

export default documentScheme;
